class BrowserStorage {
  public storage: Storage = null;

  constructor() {
    this.storage = this.checkStorageType();
  }
  // Test if local storage is possible to use
  checkStorageType() {
    let st = null;
    try {
      localStorage.setItem("test", "test");
      localStorage.removeItem("test");
      st = localStorage;
    } catch (e) {
      st = sessionStorage;
    }
    return st;
  }

  setIgAuthData(arg: string) {
    this.storage.setItem("igAuthData", arg);
  }

  setFbAuthData(arg: string) {
    this.storage.setItem("fbAuthData", arg);
  }

  getStorageItem(arg: "igAuthData" | "fbAuthData") {
    return this.storage.getItem(arg);
  }

  removeStorageItem(arg: "igAuthData" | "fbAuthData") {
    this.storage.removeItem(arg);
  }
}

let St = new BrowserStorage();

export default St;
